import { useEffect, useState } from "react";
import { oauth } from "../utils";

export default function useAcceptShopCharges() {
  const [state, setState] = useState({
    acceptShopCharges: false,
    isShopsTermsAndConditionsAccepted: false,
    loading: true,
  });
  useEffect(() => {
    let mounted = true;
    oauth("GET", "tenant/is-accepted-shop-charges", {}).then(({ json }) => {
      if (!mounted) return;
      setState({
        acceptShopCharges: +json.accept_shop_charges === 1,
        isShopsTermsAndConditionsAccepted:
          json.is_shops_terms_and_conditions_accepted === 1,
        loading: false,
      });
    });
    return () => {
      mounted = false;
    };
  }, []);
  return state;
}
